import { css, Global, withTheme } from '@emotion/react'
import * as React from 'react'

const GlobalStyles = withTheme(() => (
  <Global
    styles={css`
      .narrow {
        max-width: 775px;
        &.medium {
          max-width: 1000px;
        }
      }

      .center-text {
        text-align: center;
      }

      .center-desktop {
        @media (min-width: 768px) {
          text-align: center;
        }
      }

      .logo {
        display: block;
        margin-right: 10px;
      }

      .leshen-header {
        .bottom-bar {
          @media (max-width: 1288px) {
            padding-right: 20px !important;
            padding-left: 20px !important;
          }
        }
      }

      .leshen-footer {
        .top-section {
          img {
            max-width: 125px;
          }
        }
      }

      .red-link {
        color: #e10b3b !important;

        &:visited {
          color: #e10b3b !important;
        }
      }

      .info-cards {
        img {
          width: unset !important;
          margin: 0 auto;
        }
      }

      .uppercase {
        text-transform: uppercase;
      }

      .leshen-link {
        display: inline-block;
      }

      .zip-form-box {
        .leshen-form {
          max-width: 300px;
        }
      }

      .leshen-form-submission-message {
        margin-top: 50px;
        text-align: center;
      }
    `}
  />
))

export default GlobalStyles
